import React from 'react';
import { Container, Row, Col } from '../../../base/Grid';

import {
  TypographyStyled,
  DivPaginationContainerStyled,
} from './styles';

// Simple JSX components
// Code blocks that are reused on the first 4 views //////
export const headerRow = (
  <Row>
    <Col>
      <TypographyStyled component='h2'>
        Get matched with a financial advisor in four easy steps.
      </TypographyStyled>
    </Col>
  </Row>
);

export const getScreenNumber = x => (
  <DivPaginationContainerStyled>
    <TypographyStyled
      id={`in-page-lead-form-screen-number-${x}`}
      className='nmx-p'
      component='span'
      weight={400}>
      {x}&#47;4
    </TypographyStyled>
  </DivPaginationContainerStyled>
);

export const errorSubmittingMessage = (
  <Container>
    <Row align='center'>
      <TypographyStyled
        component='p'
        variant='h3'>
        Unable to submit form.
      </TypographyStyled>
    </Row>
  </Container>
);

